import type { AxiosDefaultError } from '@brighterly/lib-core-types/options/types'

export const getAxiosErrorMessage = (err: AxiosDefaultError): string => {
  return err.response?.data?.message || err?.message || 'Unexpected error'
}
